<template>
  <div class="container">
    <div class="title has-text-centered">
      Pending Requests
    </div>

    <FormErrors v-bind:errors="pending_requests.errors.detail" />

    <!-- PENDING REQUESTS -->
    <div class="columns is-centered">
      <div
        class="column is-8"
        style="max-height: min(600px, 60vh); overflow-y: auto;"
      >
        <ul v-if="pending_requests.data.length === 0">
          <li
            class="box has-text-centered is-centered has-text-weight-bold has-background-white"
          >
            No pending requests
          </li>
        </ul>
        <ul v-else>
          <li>
            <div class="columns is-vcentered">
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Name</p>
              </div>
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Project Title</p>
              </div>
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Action</p>
              </div>
            </div>
          </li>
          <li
            v-for="(pending_request, index) in pending_requests.data"
            class="box is-rounded mb-4"
            v-bind:key="index"
          >
            <div class="columns is-vcentered">
              <div class="column">
                <router-link v-bind:to="{ name: 'MenteeRequestProfilePage', params: { profile_uid: pending_request.mentee , mentorship_request_uid : pending_request.uid } }"
										 class="hyperlink">
                  {{ pending_request.mentee_name }}
                </router-link>
              </div>
              <div class="column">
                {{ pending_request.project_title }}
              </div>
              <div class="column is-narrow">
                {{ get_status(pending_request.status) }}
              </div>
              <div class="column is-narrow">
                <button
                  v-on:click="show_request_details(index)"
                  class="button is-info mr-2"
                >
                  <span class="icon"><i class="fas fa-info"></i></span>
                </button>
                <button
                  v-on:click="accept_pending_request(index)"
                  class="button is-success mr-2"
                  v-if="pending_request.status == 1"
                >
                  <span class="icon"><i class="fas fa-check"></i></span>
                </button>
                <button
                  v-on:click="accept_pending_request(index)"
                  class="button is-success mr-2"
                  disabled
                  v-else
                >
                  <span class="icon"><i class="fas fa-check"></i></span>
                </button>
                <!-- TODO Rename reject to decline in backend and frontend -->
                <button
                  v-if="pending_request.status == 1"
                  v-on:click="show_reject_reason_modal(index, 4)"
                  class="button is-warning mr-2"
                >
                  <span class="icon"><i class="fas fa-undo"></i></span>
                </button>
                <button
                  v-else
                  v-on:click="show_reject_reason_modal(index, 4)"
                  class="button is-warning mr-2"
                  disabled
                >
                  <span class="icon"><i class="fas fa-undo"></i></span>
                </button>
                <button
                  v-if="pending_request.status == 1"
                  v-on:click="show_reject_reason_modal(index, 3)"
                  class="button is-danger"
                >
                  <span class="icon"><i class="fas fa-times"></i></span>
                </button>
                <button
                  v-else
                  v-on:click="show_reject_reason_modal(index, 3)"
                  disabled
                  class="button is-danger"
                >
                  <span class="icon"><i class="fas fa-times"></i></span>
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- SPECIFY DECLINE REASON MODAL -->
    <div
      v-bind:class="{ 'is-active': pending_requests.modals.reject_reason.show }"
      class="modal"
    >
      <div
        class="modal-background"
        v-on:click="clear_and_close_reject_reason_modal"
      ></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <span v-if="pending_requests.modals.reject_reason.content.status == 3" class="modal-card-title">Decline request</span>
          <span v-if="pending_requests.modals.reject_reason.content.status == 4" class="modal-card-title">Request for resubmit</span>
          <button
            v-on:click="clear_and_close_reject_reason_modal"
            class="delete"
            aria-label="close"
          ></button>
        </header>

        <section class="modal-card-body has-text-left">
          <InputBox
            input_type="textarea"
            v-model="
              pending_requests.modals.reject_reason.content.reject_reason
            "
            v-bind:errors="
              pending_requests.modals.reject_reason.errors.reject_reason
            "
            placeholder="Specify the reason for declining the request"
            label="Reject Reason (Optional)"
            icon="fas fa-info-circle"
          />

          <FormErrors
            v-bind:errors="pending_requests.modals.reject_reason.errors.detail"
          />
          <FormErrors
            v-bind:errors="
              pending_requests.modals.reject_reason.errors.non_field_errors
            "
          />
          <div>
            <input type="checkbox" id="checkbox" v-model="pending_requests.modals.reject_reason.content.block" />
            <label class = "pl-1" for="checkbox">Block the mentee completely</label>
          </div>
        </section>
        
        <footer class="modal-card-foot">
          <div class="columns is-mobile" style="width: 100%;">
            <div class="column has-text-right">
              <button
                v-on:click="reject_pending_request"
                class="button is-danger"
              >
                Confirm
              </button>
              <button
                v-on:click="clear_and_close_reject_reason_modal"
                class="button"
              >
                Close
              </button>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <!-- VIEW PARTICULAR REQUEST DETAILS MODAL -->
    <div
      v-bind:class="{
        'is-active': pending_requests.modals.request_details.show,
      }"
      class="modal"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Request details</p>
          <button
            v-on:click="pending_requests.modals.request_details.show = false"
            class="delete"
            aria-label="close"
          ></button>
        </header>

        <div class="modal-card-body">
          <div class="content">
            <div>
              <strong>Statement of purpose</strong>
              <p>
                {{
                  pending_requests.modals.request_details.content
                    .statement_of_purpose
                }}
              </p>
            </div>
            <hr />
            <div>
              <strong>Commitment in months</strong>
              <p>
                {{ pending_requests.modals.request_details.content.commitment }}
              </p>
            </div>
            <hr />
            <div>
              <strong>Expectations</strong>
              <p>
                {{
                  pending_requests.modals.request_details.content.expectations
                }}
              </p>
            </div>
            <hr v-if="pending_requests.modals.reject_reason.content.reject_reason.length != 0"/>
            <div v-if="pending_requests.modals.reject_reason.content.reject_reason.length != 0">
              <strong>Reject Reason</strong>
              <p v-if="pending_requests.modals.reject_reason.content.reject_reason.length == 0">
                No data
              </p>
              <p v-else>
                {{
                  pending_requests.modals.reject_reason.content.reject_reason
                }}
              </p>
            </div>
            <hr />
            <div v-if="priorityChecklist" class="control">
              <strong>Priority Checklist</strong>
              <ul style="list-style: none">
                <li v-for="item in priorityChecklist" v-bind:key="item.uid">
                  <label class="checkbox pb-2">
                    <input
                      type="checkbox"
                      v-bind:value="item.uid"
                      disabled="disabled"
                      :checked="isPriorityItemChecked(item.uid)"
                    />
                    {{ item.label }} ({{ PRIORITY_VALUES[item.priority] }})
                  </label>
                </li>
              </ul>
            </div>
            <div class="control" v-if="pending_requests.modals.request_details.content.submission_file_name">
              <strong>Submission by mentee</strong>
              <br>
              <p v-if="pending_requests.modals.request_details.content.project_title"> 
                <span style="font-weight: bolder;">Project title:</span>{{ pending_requests.modals.request_details.content.project_title }}
              </p>
              <!-- <br> -->
              {{ pending_requests.modals.request_details.content.submission_file_name }}
              <button v-on:click="download_file" class="button is-primary">
                Download
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import axios from '../../api/my-axios';
import InputBox from '../../components/FormHelpers/InputBox';
import FormErrors from '../../components/FormHelpers/FormErrors';
import { PRIORITY_VALUES } from '../../lib';

export default {
  components: {
    InputBox,
    FormErrors,
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
    // ...mapGetters({
    // 	role: "role"
    // })
  },
  data() {
    return {
      pending_requests: {
        request_token: {
          // accepted: true,
          // [reject_reason]: "" (mandatory if accepted is false)
        },

        errors: {},

        delete_index: -1, // The index of the request in data being declined


        modals: {
          reject_reason: {
            show: false,
            content: {
              status: 1,
              reject_reason: '',
              block : false,
            },
            errors: {},
          },

          request_details: {
            show: false,
            status: 2,
            content: {
              statement_of_purpose: '',
              commitment: '',
              expectations: '',
              checklist: [],
              project_title: "",
              submission_file: null,
              submission_file_name: null,
            },
          },
        },

        data: [
          // {
          //
          // }
        ],
      },
      priorityChecklist: null,
      PRIORITY_VALUES,
    };
  },
  created() {
    this.get_pending_mentorship_requests();
    this.getPriorityChecklistItems();
  },
  methods: {
    clear_reject_reason_modal() {
      for (const key in this.pending_requests.modals.reject_reason.content) {
        this.pending_requests.modals.reject_reason.content[key] = '';
      }

      this.pending_requests.modals.reject_reason.errors = {};
    },

    clear_and_close_reject_reason_modal() {
      this.clear_reject_reason_modal();
      this.pending_requests.modals.reject_reason.show = false;
    },

    show_request_details(index) {
      if (index < 0 || index >= this.pending_requests.data.length) {
        return;
      }

      for (const key in this.pending_requests.modals.request_details.content) {
        this.pending_requests.modals.request_details.content[
          key
        ] = this.pending_requests.data[index][key];
      }

      this.pending_requests.modals.reject_reason.content.reject_reason = this.pending_requests.data[index]['reject_reason']
      this.pending_requests.modals.reject_reason.content.status = this.pending_requests.data[index]['status']

      this.pending_requests.modals.request_details.show = true;
    },

    show_reject_reason_modal(index, status) {
      if (index < 0 || index >= this.pending_requests.data.length) {
        return;
      }
      this.pending_requests.modals.reject_reason.content.reject_reason = this.pending_requests.data[index]['reject_reason']
      this.pending_requests.delete_index = index;
      this.pending_requests.modals.reject_reason.show = true;
      this.pending_requests.modals.reject_reason.content.status = status;
    },

    download_file(){
      // console.log(API_URL)
      console.log(this.pending_requests.modals.request_details)
      var url = this.pending_requests.modals.request_details.content.submission_file;
      window.open(url, '_blank');
    },

    get_pending_mentorship_requests() {
      axios
        .get('/api/mentorship/request/pending/', {
          params: {
            mentor: this.user.profile_uid,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.pending_requests.data = response.data;
          this.pending_requests.data.sort((a, b) =>
            a.priority_rating > b.priority_rating ? -1 : 1
          );
        })
        .catch((error) => {
          this.pending_requests.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },

    getPriorityChecklistItems() {
      axios
        .get(`/api/mentor/checklist/?mentor=${this.user.profile_uid}`)
        .then((res) => {
          this.priorityChecklist = res.data;
          this.priorityChecklist.sort((a, b) =>
            a.priority > b.priority ? -1 : 1
          );
        })
        .catch((err) => console.error(err));
    },

    isPriorityItemChecked(uid) {
      return this.pending_requests.modals.request_details.content.checklist.find(
        (item_uid) => item_uid === uid
      );
    },

    accept_pending_request(index) {
      if (index < 0 || index >= this.pending_requests.data.length) {
        return;
      }

      // TODO Set the URL
      axios
        .post(
          `/api/mentorship/request/${this.pending_requests.data[index].uid}/respond/`,
          {
            status: 2,
            block: false,
          }
        )
        .then((_) => {
          this.pending_requests.data.splice(index, 1);
        })
        .catch((error) => {
          this.pending_requests.errors = error.response.data;
        });
    },

    reject_pending_request() {
      if (
        this.pending_requests.delete_index < 0 ||
        this.pending_requests.delete_index >= this.pending_requests.data.length
      ) {
        return;
      }

      // TODO Set the URL
      axios
        .post(
          `/api/mentorship/request/${
            this.pending_requests.data[this.pending_requests.delete_index].uid
          }/respond/`,
          {
            ...this.pending_requests.modals.reject_reason.content,
          }
        )
        .then((_) => {
          // this.pending_requests.data.splice(
          //   this.pending_requests.delete_index,
          //   1
          // );
          console.log(this.pending_requests.data, this.pending_requests.modals);
          this.pending_requests.data[this.pending_requests.delete_index].status = this.pending_requests.modals.reject_reason.content.status;
          this.clear_and_close_reject_reason_modal();
        })
        .catch((error) => {
          // console.log(error)
          this.pending_requests.errors = error.response.data;
        });
    },

    get_status(status){
      if (status == 1){
        return "Pending";
      }
      else if (status == 2){
        return "Accepted";
      }
      else if (status == 3){
        return "Rejected";
      }
      else if (status == 4){
        return "Resubmit";
      }
    },
  },
};
</script>

<style scoped>
.pending-requests td {
  border: none !important;
}
</style>
